<div class="fp-page" [class.fp-page--dialog]="dialogRef">

  <!-- ── LOADING ──────────────────────────────────────────────── -->
  <div class="fp-loading" *ngIf="!ready">
    <div class="fp-loading__icon"><mat-icon>people</mat-icon></div>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="fp-loading__text">Cargando formulario…</p>
  </div>

  <ng-container *ngIf="ready">

    <!-- ── HEADER (modo página) ───────────────────────────────── -->
    <div class="fp-header" *ngIf="!dialogRef">
      <div class="fp-header__icon"><mat-icon>people</mat-icon></div>
      <div>
        <h1 class="fp-header__title">{{ financiacionPropia.uid ? 'Editar financiación propia' : 'Nueva financiación propia' }}</h1>
        <p class="fp-header__sub">{{ financiacionPropia.uid ? 'Modifica los datos' : 'Registra una nueva financiación propia' }}</p>
      </div>
      <button mat-flat-button class="fp-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

    <!-- ── HEADER (modo dialog) ──────────────────────────────── -->
    <div mat-dialog-title class="fp-dlg-title" *ngIf="dialogRef">
      <div class="fp-dlg-title__left">
        <div class="fp-header__icon"><mat-icon>people</mat-icon></div>
        <span>Financiación propia</span>
      </div>
      <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- ── AVISO IMPORTACIÓN ─────────────────────────────────── -->
    <div class="fp-import-notice" *ngIf="flagImport">
      <mat-icon>info</mat-icon>
      <span><strong>Importación:</strong> {{ movement.reference }}</span>
    </div>

    <!-- ── BODY ───────────────────────────────────────────────── -->
    <div class="fp-body" [class.fp-body--dialog]="dialogRef">
      <form onkeypress="return event.keyCode != 13;">
        <div class="fp-grid">

          <!-- COLUMNA IZQUIERDA -->
          <div class="fp-left">

            <!-- SECCIÓN: Identificación -->
            <div class="fp-section">
              <div class="fp-section__head">
                <mat-icon>perm_identity</mat-icon>
                <span>Identificación</span>
              </div>
              <div class="fp-section__body">

                <div class="fp-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Duración</mat-label>
                    <mat-select [(ngModel)]="financiacionPropia.duracion" name="duracion"
                      (selectionChange)="duracionChangeValue($event.value)" required>
                      <mat-option [value]="1">Corto Plazo</mat-option>
                      <mat-option [value]="2">Largo Plazo</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <app-select [(ngModel)]="financiacionPropia.cuentaContableACrear" name="cuentaContableACrear"
                    [config]="{ label: 'Cuenta contable', required: true, loadOptions: () => cuentaContableOptions }">
                  </app-select>
                </div>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Socio</mat-label>
                  <input matInput [(ngModel)]="financiacionPropia.partnersName"
                    name="financiacionPropia.partnersName"
                    [matAutocomplete]="auto" [formControl]="partnersControl" required [readonly]="readOnly">
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let partners of partnersfiltered | async; trackBy: trackByIndex"
                      [value]="partners.nameOrBusinessName"
                      (click)="setPartnerIdentifier(partners.uid)">
                      {{ partners.nameOrBusinessName }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <app-input inputType="text" placeholder="Descripción" [isRequired]="true"
                  [(ngModel)]="financiacionPropia.descripcion"></app-input>

              </div>
            </div>

            <!-- SECCIÓN: Plazos -->
            <div class="fp-section">
              <div class="fp-section__head">
                <mat-icon>date_range</mat-icon>
                <span>Plazos</span>
              </div>
              <div class="fp-section__body">

                <div class="fp-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de constitución</mat-label>
                    <input matInput [matDatepicker]="fechaConstitucion" name="financiacionPropia.fechaConstitucion"
                      [(ngModel)]="financiacionPropia.fechaConstitucion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaConstitucion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaConstitucion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Plazo (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="financiacionPropia.plazo"
                      name="financiacionPropia.plazo" required>
                  </mat-form-field>
                </div>

                <div class="fp-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de finalización</mat-label>
                    <input matInput [matDatepicker]="fechaFinalizacion" name="financiacionPropia.fechaFinalizacion"
                      [(ngModel)]="financiacionPropia.fechaFinalizacion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaFinalizacion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaFinalizacion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Carencia (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="financiacionPropia.carencia"
                      name="financiacionPropia.carencia" required>
                  </mat-form-field>
                </div>

              </div>
            </div>

          </div>

          <!-- COLUMNA DERECHA -->
          <div class="fp-right">

            <!-- SECCIÓN: Importes y condiciones -->
            <div class="fp-section">
              <div class="fp-section__head">
                <mat-icon>attach_money</mat-icon>
                <span>Importes y condiciones</span>
              </div>
              <div class="fp-section__body">

                <div class="fp-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe inicial</mat-label>
                    <input matInput type="text" [(ngModel)]="financiacionPropia.importeInicial"
                      name="financiacionPropia.importeInicial" numberDecimalsDirective required>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe pendiente</mat-label>
                    <input matInput type="text" [(ngModel)]="financiacionPropia.importePendiente"
                      name="financiacionPropia.importePendiente" numberDecimalsDirective required>
                  </mat-form-field>
                </div>

                <div class="fp-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Comisión apertura</mat-label>
                    <input matInput type="text" [(ngModel)]="financiacionPropia.comisionApertura"
                      name="financiacionPropia.comisionApertura" numberDecimalsDirective required>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tipo de interés</mat-label>
                    <input matInput type="text" [(ngModel)]="financiacionPropia.tipoInteres"
                      name="financiacionPropia.tipoInteres" numberDecimalsDirective required>
                  </mat-form-field>
                </div>

              </div>
            </div>

            <!-- SECCIÓN: Liquidaciones y cuenta -->
            <div class="fp-section">
              <div class="fp-section__head">
                <mat-icon>account_balance_wallet</mat-icon>
                <span>Liquidaciones y cuenta</span>
              </div>
              <div class="fp-section__body">

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Tipo de liquidaciones</mat-label>
                  <mat-select [(ngModel)]="financiacionPropia.tipoLiquidaciones" name="tipoLiquidaciones" required>
                    <mat-option [value]="0">Sin seleccionar</mat-option>
                    <mat-option [value]="1">Mensual</mat-option>
                    <mat-option [value]="2">Bimensual</mat-option>
                    <mat-option [value]="3">Trimestral</mat-option>
                    <mat-option [value]="4">Semestral</mat-option>
                    <mat-option [value]="5">Anual</mat-option>
                  </mat-select>
                </mat-form-field>

                <app-autocomplete-select [items]="bankAccounts"
                  [(selectedItemId)]="financiacionPropia.bankAccountsUid"
                  [idField]="'uid'" [displayFields]="['bank', 'iban']"
                  placeholder="Cuenta de adeudo" class="w-100">
                </app-autocomplete-select>

              </div>
            </div>

          </div>

        </div>
      </form>
    </div>

    <!-- ── ACTIONS (modo dialog) ────────────────────────────── -->
    <mat-dialog-actions align="end" *ngIf="dialogRef">
      <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
      <button mat-flat-button class="fp-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </mat-dialog-actions>

  </ng-container>

</div>
